import React, { ReactElement, useState } from 'react';
import { Alert, Button } from '@mui/material';
import { RetroBetaInfoDialog } from './RetroBetaInfoDialog';

/**
 * Up-front beta disclaimer shown before someone creates or joins a retro
 * room. Kept to a single line so it doesn't crowd the form; full context
 * lives in `RetroBetaInfoDialog`, opened via "Learn more".
 */
export function RetroBetaBanner(): ReactElement {
  const [isInfoOpen, setIsInfoOpen] = useState(false);

  return (
    <>
      <Alert
        severity="info"
        action={
          <Button color="inherit" size="small" onClick={() => setIsInfoOpen(true)}>
            Learn more
          </Button>
        }
      >
        Retro Room is an early beta — your data is always yours to export, no lock-in.
      </Alert>
      <RetroBetaInfoDialog open={isInfoOpen} onClosed={() => setIsInfoOpen(false)} />
    </>
  );
}

export default RetroBetaBanner;
